import { ScriptCategoryRestControllerService } from '@api'
import { attach, createEffect } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { toast } from '@/models/toasts.ts'
import { handleError } from '@/utils/error'

export const addScriptsCategoryFx = attach({
  name: 'add scripts category',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (name: string, { creatorId }) => ({
    creatorId: creatorId!,
    requestBody: { name },
  }),
  effect: createEffect(ScriptCategoryRestControllerService.addScriptCategory),
})

addScriptsCategoryFx.doneData.watch(() => {
  toast.success('Folder created successfully')
})

addScriptsCategoryFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while adding scripts category')
})

export const editScriptsCategoryFx = attach({
  name: 'edit scripts category',
  source: {
    creatorId: $creatorId,
  },
  mapParams: ({ name, id }: { name: string; id: number }, { creatorId }) => ({
    creatorId: creatorId!,
    id,
    requestBody: { name },
  }),
  effect: createEffect(ScriptCategoryRestControllerService.editScriptCategory),
})

editScriptsCategoryFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while editing scripts category')
})

editScriptsCategoryFx.doneData.watch(() => {
  toast.success('Folder renamed successfully')
})

export const deleteScriptsCategoryFx = attach({
  name: 'delete scripts category',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (
    data: {
      id: number
      contentPolicy: 'DELETE' | 'UNLINK'
    },
    { creatorId },
  ) => ({
    ...data,
    creatorId: creatorId!,
  }),
  effect: createEffect(
    ScriptCategoryRestControllerService.removeScriptCategory,
  ),
})

deleteScriptsCategoryFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while deleting scripts category')
})

deleteScriptsCategoryFx.doneData.watch(() => {
  toast.success('Folder deleted')
})

export const moveScriptsCategoryFx = attach({
  name: 'move scripts category',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (ids: number[], { creatorId }) => ({
    creatorId: creatorId!,
    requestBody: ids,
  }),
  effect: createEffect(ScriptCategoryRestControllerService.moveScriptCategory),
})

moveScriptsCategoryFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while moving scripts category')
})
